// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconInboxPath = 'M14 0v2h-2v2h3.966a3.9 3.9 0 0 1 2.894 1.14 3.89 3.89 0 0 1 1.142 2.636L20 17h-8v3h-2v-3H0L0 7.804A3.9 3.9 0 0 1 4.017 4H10V0h4Zm-4 9V6H7.51c.342.613.515 1.307.49 2v7h10l.001-7.035a1.9 1.9 0 0 0-.437-1.281l-.118-.13a1.905 1.905 0 0 0-1.26-.552H12V9h-2ZM4 6h-.034a1.9 1.9 0 0 0-1.41.555A1.923 1.923 0 0 0 2 8v7h4V7.965a1.9 1.9 0 0 0-.437-1.281l-.118-.13A1.9 1.9 0 0 0 4.186 6H4Z';
var IconInbox = baseIcon('IconInbox', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconInboxPath
});
export default IconInbox;
//# sourceMappingURL=index.js.map